module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-750-Classes-Inactive-a89572a48d6953c39495afd5c207d574.png";